/**
 * @store 门户 企业 模块
 */

import {api} from "@/api";

export default {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    /**
     * 实时资讯
     * @param _
     * @param data
     * @returns {Promise<AxiosResponse<any>>}
     */
    async queryList(_, data) {
      return await api.post(`/api/article/newsList`, data);
    },
    async queryDetail(_, data) {
      return await api.post(`/api/article/detail`, data);
    },
  },
}
